module.exports = __webpack_public_path__ + "static/media/how-it-works3.453e22bf.png";